export type LangKey = 'curl' | 'python' | 'node';

export type Snippet = {
  label: string;
  html: string;
  raw: string;
};

export const SNIPPETS: Record<LangKey, Snippet> = {
  curl: {
    label: 'cURL',
    html: `<span class="c"># Ask a question. Get the answer and its sources.</span>
curl -X POST <span class="s">'https://api.globaldatabase.com/v1/regis/query'</span> \\
  -H <span class="s">'Authorization: Token YOUR_API_KEY'</span> \\
  -H <span class="s">'Content-Type: application/json'</span> \\
  -d <span class="s">'{
    "prompt": "Is Global Data Intelligence Limited still active, and what is its registered office?"
  }'</span>`,
    raw: `curl -X POST 'https://api.globaldatabase.com/v1/regis/query' \\
  -H 'Authorization: Token YOUR_API_KEY' \\
  -H 'Content-Type: application/json' \\
  -d '{
    "prompt": "Is Global Data Intelligence Limited still active, and what is its registered office?"
  }'`,
  },
  python: {
    label: 'Python',
    html: `<span class="k">import</span> requests

r = requests.post(
    <span class="s">"https://api.globaldatabase.com/v1/regis/query"</span>,
    headers={<span class="s">"Authorization"</span>: <span class="s">"Token YOUR_API_KEY"</span>},
    json={<span class="s">"prompt"</span>: <span class="s">"Is Global Data Intelligence Limited still active, and what is its registered office?"</span>},
    timeout=<span class="k">60</span>,
)

answer = r.json()
<span class="k">print</span>(answer[<span class="s">"answer"</span>])
<span class="k">print</span>(answer[<span class="s">"sources"</span>])  <span class="c"># register, filing reference, retrieved_at</span>`,
    raw: `import requests

r = requests.post(
    "https://api.globaldatabase.com/v1/regis/query",
    headers={"Authorization": "Token YOUR_API_KEY"},
    json={"prompt": "Is Global Data Intelligence Limited still active, and what is its registered office?"},
    timeout=60,
)

answer = r.json()
print(answer["answer"])
print(answer["sources"])`,
  },
  node: {
    label: 'Node.js',
    html: `<span class="k">const</span> res = <span class="k">await</span> fetch(<span class="s">"https://api.globaldatabase.com/v1/regis/query"</span>, {
  method: <span class="s">"POST"</span>,
  headers: {
    <span class="s">"Authorization"</span>: <span class="s">"Token YOUR_API_KEY"</span>,
    <span class="s">"Content-Type"</span>: <span class="s">"application/json"</span>
  },
  body: JSON.stringify({
    prompt: <span class="s">"Is Global Data Intelligence Limited still active, and what is its registered office?"</span>
  })
});

<span class="k">const</span> { answer, sources } = <span class="k">await</span> res.json();`,
    raw: `const res = await fetch("https://api.globaldatabase.com/v1/regis/query", {
  method: "POST",
  headers: {
    "Authorization": "Token YOUR_API_KEY",
    "Content-Type": "application/json"
  },
  body: JSON.stringify({
    prompt: "Is Global Data Intelligence Limited still active, and what is its registered office?"
  })
});

const { answer, sources } = await res.json();`,
  },
};

export const LANG_ORDER: LangKey[] = ['curl', 'python', 'node'];
